import React from 'react';

interface GatewayContextProps {
  gatewayCurrentStatus: string;
  setGatewayCurrentStatus: React.Dispatch<React.SetStateAction<string>>;
  isPanicSituation: boolean;
  setIsPanicSituation: React.Dispatch<React.SetStateAction<boolean>>;
}
export const GatewayContext = React.createContext({} as GatewayContextProps);
